/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ section: NonNullable<unknown> }} Meeting_Report_Section_LabelInputs */



/**
* | output |
* | --- |
* | "Text under {section}" |
*
* @param {Meeting_Report_Section_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_section_label = /** @type {((inputs: Meeting_Report_Section_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Section_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Tekst onder ${i?.section}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Texte sous ${i?.section}`)
	return /** @type {LocalizedString} */ (`Text under ${i?.section}`)
});